import React from 'react';

interface ResizeHandleProps {
  column: string;
  onMouseDown: (e: React.MouseEvent, column: string) => void;
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  column,
  onMouseDown,
}) => (
  <div
    onMouseDown={(e) => onMouseDown(e, column)}
    className="absolute top-0 right-0 z-10 h-full cursor-col-resize bg-transparent transition-colors hover:bg-blue-400"
    style={{ width: '6px', marginRight: '-3px' }}
  />
);
